import React, { useState, useEffect, useContext } from 'react';
import styles from './styles.module.css';
import { TextField, Grid, InputAdornment, Box, Button, IconButton } from '@mui/material';
import AuthService from 'services/AuthService';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { STORAGE_KEYS, ROUTES } from 'const';
import usernameIcon from './person.svg';
import passwordIcon from './lock.svg';
// import google from './google.png';
// import facebook from './facebook.png';
// import twiter from './twiter.png';
import { ThemeContext } from 'Context/ThemeContext';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DateTimeHelpers from 'helpers/DateTimeHelpers';

export default function Login(props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loadingIndicator, setLoadingIndicator] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const history = useHistory();
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    if (token) {
      history.push(ROUTES.HOME);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loginBtnPressed = async () => {
    setErrorMessage(null);
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();
    if (!trimmedUsername || !trimmedPassword) {
      setErrorMessage('Username and Password should not be empty.');
      return;
    }
    setLoadingIndicator(true);
    const error = await AuthService.login(trimmedUsername, trimmedPassword);
    setLoadingIndicator(false);
    if (error) {
      let errorMsg = error?.response?.data?.message || error?.message || 'Failed to login!';
      const statusCode = error?.response?.data?.status_code;
      if (
        statusCode === 'ACCOUNT_WAS_BLOCKED_DUE_TO_INVALID_LOGIN_ATTEMPT' ||
        statusCode === 'ACCOUNT_IS_BLOCKED_DUE_TO_INVALID_LOGIN_ATTEMPT' ||
        statusCode === 'ACCOUNT_BLOCKED_DUE_TO_INVALID_LOGIN_ATTEMPT'
      ) {
        const unlockTime = error?.response?.data?.data?.unlock_time;
        if (unlockTime) {
          errorMsg = `Your account is blocked until ${DateTimeHelpers.formatDateTime(
            unlockTime
          )}. Please login after that.`;
        }
      }
      setErrorMessage(errorMsg);
    } else {
      history.push(ROUTES.HOME);
    }
  };

  const handleWhatsAppRedirect = () => {
    const url = `https://api.whatsapp.com/send?phone=919074511134&text=${encodeURIComponent(
      'Need help on Sanoft POS'
    )}`;
    window.open(url, '_blank');
  };

  return (
    <div style={{ backgroundColor: theme.color.bg_color }} className={styles.mainDiv}>
      <Box container style={{ borderColor: theme.color.header }} className={styles.outerBoxFrame}>
        {/* <Hidden xsDown>
          <Grid item xs={12} sm={12} className={styles.formBoxFrame}>
            <Grid className={styles.welcome}>
              <span style={{ color: '#3F8DCE' }}>SANOFT</span>
              <span style={{ color: '#3C465B', marginLeft: 10 }}>POS</span>
            </Grid>
            <Grid className={styles.paddingp} style={{ textAlign: 'center' }}>
              <h5>TOTAL WEIGHING SOLUTIONS</h5>
              <p
                style={{ color: '#404040', lineHeight: 1.5, textAlign: 'left' }}
              >
                . Bill Printing Scale
                <br />
                . Label Printing Scale
                <br />
                . Bench Price Computing Scale
                <br />
                . Price Computing Scale ATM Keypad
                <br />
              </p>
            </Grid>
            <Grid className={styles.btnKnwon}>
              <Button
                size="small"
                variant="contained"
                onClick={() => window.open('http://www.weighvox.com', '_blank')}
              >
                Known More
              </Button>
            </Grid>
          </Grid>
        </Hidden> */}
        <Grid style={{ boxShadow: 3 }} item xs={12} sm={12} className={styles.formBoxFrame}>
          <Grid>
            <Grid className={styles.welcome}>
              <span style={{ color: theme.color.header }}>{theme.variable.name}</span>
              <span style={{ color: '#3C465B', marginLeft: 10 }}>POS</span>
            </Grid>
            <div className={styles.textCenter}>
              <TextField
                name="username"
                size="small"
                label="Username"
                type="text"
                placeholder="type your username"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        alt="Sanoft POS – best billing software and best billing app for small businesses"
                        src={usernameIcon}
                        width="18"
                        height="18"
                      />
                    </InputAdornment>
                  ),
                }}
                onChange={(event) => {
                  setUsername(event.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    loginBtnPressed();
                  }
                }}
                autoComplete="current-username"
                color="primary"
                fullWidth
              />
            </div>
            <div className={styles.textCenter}>
              <TextField
                name="password"
                size="small"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                margin="normal"
                placeholder="type your password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        alt="Sanoft POS – best billing software and best billing app for small businesses"
                        src={passwordIcon}
                        width="18"
                        height="18"
                      />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" sx={{ color: 'gray' }}>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    loginBtnPressed();
                  }
                }}
                autoComplete="current-password"
                color="primary"
                fullWidth
              />
            </div>
            <div className={styles.errorMsg}>{errorMessage && <span>{errorMessage}</span>}</div>
            <Grid className={styles.forgotPasswordWrapper}>
              <Link to="/reset-password" className={styles.forgotPassword}>
                Forgot password?
              </Link>
            </Grid>
            <Grid className={styles.textCenter}>
              <Button
                className={styles.loginButton}
                variant="contained"
                type="submit"
                onClick={loginBtnPressed}
                disabled={loadingIndicator}
                fullWidth
                style={{
                  backgroundColor: theme.color.header,
                  color: 'white',
                }}
              >
                Login {loadingIndicator && '...'}
              </Button>
            </Grid>

            {/*<Grid*/}
            {/*  container*/}
            {/*  justifyContent={'center'}*/}
            {/*  className={styles.socialSignInWrapper}*/}
            {/*>*/}
            {/*  <Grid className={styles.socialMeadiaLogin}>*/}
            {/*    <img alt="" src={facebook} width="25" height="25" />*/}
            {/*  </Grid>*/}
            {/*  <Grid className={styles.socialMeadiaLogin}>*/}
            {/*    <img alt="" src={google} width="25" height="25" />*/}
            {/*  </Grid>*/}
            {/*  <Grid className={styles.socialMeadiaLogin}>*/}
            {/*    <img alt="" src={twiter} width="25" height="25" />*/}
            {/*  </Grid>*/}
            {/*</Grid>*/}

            <Grid className={styles.signupHintWrapper}>
              <span>Doesn't have an account? </span>
              <Link to={ROUTES.PRICING}>Register</Link>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <div className={styles.contactIconContainer} onClick={handleWhatsAppRedirect}>
        <WhatsAppIcon style={{ fontSize: '32px', color: '#fff' }} />
      </div>
    </div>
  );
}
